<template>
  <div id="contactView" class="statv_container statv_page_bg">
		<section class="statv_wrapper statv_page_wrapper">
			<h1 class="statv_page_title"> 사업제휴문의 </h1>
			<div class="card_view">
				<article v-for="(item, idx) in contacts" :key="`contact_${idx}`" class="card_item">
					<h3 class="dept"> {{item.dept}} </h3>
					<p class="contents"> {{item.contents}} </p>
					<div class="info">
						<p class="manager"> {{item.contact1_team}} | {{item.contact1_name}}</p>
						<address class="email"> {{item.contact1_email}} </address>
					</div>
					<div class="info">
						<p v-if="item.contact2_team && item.contact2_name" class="manager"> 
							{{item.contact2_team}} | {{item.contact2_name}}
						</p>
						<address v-if="item.contact2_email" class="email"> {{item.contact2_email}} </address>
					</div>
				</article>
			</div>
    </section>
  </div>
</template>
<script>
import * as Store from "@/store/modules/contact"
export default {
  data() {
    return {

    }
  },
  async created() {
	  await this.getContacts()
  },
  computed: {
	  ...Store.mapState([ "contacts" ])
  },
  methods: {
	  ...Store.mapActions([ "getContacts" ])
	}
}
</script>
<style lang="less">
.statv_page_bg {
	padding-bottom: 100px !important;
}
#contactView {
	.card_view {
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
		align-items: center;
		padding: 0 75px;
		padding-top: 90px;
		.card_item {
			display: flex;
			flex-flow: column wrap;
			width: 400px;
			height: 200px;
			transform: skew(-0.05deg);
			margin: 0 25px;
			.dept {
				font-size: 22px;
				font-weight: 600;
				color: #ff6400;
				padding-bottom: 8px;
				border-bottom: 1px solid #ff6400;
			}
			.contents {
				width: 379px;
				font-size: 16px;
				font-weight: 400;
				color: #8F8F8F;
				padding-right: 25px;
				margin: 15px 0;
				line-height: 1.2;
			}
			.info {
				display: flex;
				flex-flow: row wrap;
				font-size: 16px;
				font-weight: bold;
        line-height: 23px;

				.manager {
					margin-right: 10px;
					color: #8F8F8F;
				}
				.email {
					color:#ff6400;
				}
			}
		}
	}
}
.m .statv_page_bg {
	padding-bottom: 160px !important;
}
.m #contactView {
	.card_view {
		padding: 0;
		padding-top: 55px;		
		justify-content: flex-start;
		.card_item {
			height: auto;
			width: 100%;
			margin-bottom: 100px;
			.dept {
				font-size: 34px;
			}
			.contents {
				width: 568px;
				font-size: 24px;
				margin: 25px 0 30px 0;
			}
			.info {
				font-size: 24px;
        line-height: 35px;
			}
		}
		.card_item:last-child {
			margin-bottom: 0;
		}
	}
}
</style>